import {
  SourceDef,
  SourceDictionary,
} from "@/models/legislation/LegislationFilter";
import { PATH_KEYS } from "@/services/appServices";
import { useQuery } from "@tanstack/react-query";
import { useItemService } from "./useServices";
import { restError } from "@/models/client/RestResponse";

const useLegislationFilters = () => {
  const legislationFilterService = useItemService(
    (services) => services.legislationFilter
  );

  const useGetFilterConfiguration = () =>
    useQuery<SourceDictionary>({
      queryKey: [PATH_KEYS.legislationFilter, "filter-configuration"],
      queryFn: async () => {
        const res = await legislationFilterService.getFilterConfiguration();
        if (res.success) return res.value;
        throw restError(res);
      },
    });

  const useGetSourcedFilterConfiguration = (source: string) =>
    useQuery<SourceDef>({
      queryKey: [PATH_KEYS.legislationFilter, "filter-configuration", source],
      queryFn: async () => {
        const res =
          await legislationFilterService.getSourcedFilterConfigarution(source);
        if (res.success) return res.value;
        throw restError(res);
      },
    });

  const useGetDefaultFilterConfiguration = () =>
    useQuery<SourceDictionary>({
      queryKey: [
        PATH_KEYS.legislationFilter,
        "filter-configuration",
        "default",
      ],
      queryFn: async () => {
        const res =
          await legislationFilterService.getDefaultFilterConfiguration();
        if (res.success) return res.value;
        throw restError(res);
      },
    });

  return {
    useGetFilterConfiguration,
    useGetSourcedFilterConfiguration,
    useGetDefaultFilterConfiguration,
  };
};

export default useLegislationFilters;
